// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"868cfd4e","977":"cb39b42c"}[chunkId] + ".chunk.js";
};